<app-header [user]="user()" />

<div class="www-document">
  <p align="center"><b>L’OREAL POLSKA SP. Z O.O.</b></p>

  <p align="center"><b>TABELA PLIKÓW COOKIES</b></p>

  <p align="center">&nbsp;</p>

  <h2>CZYM SĄ PLIKI COOKIES?</h2>

  <p>
    Pliki Cookies to niewielkie pliki tekstowe przechowywane na Twoim urządzeniu (komputerze, tablecie lub telefonie
    komórkowym), kiedy jesteś połączony z Internetem co obejmuje strony internetowe Grupy L’Oréal. Pliki Cookies mogą
    zawierać ustawienia witryn lub być używane do śledzenia interakcji użytkowników z witryną. W celu uzyskania dalszych
    informacji prosimy o zapoznanie się z następującą stroną:
    <a href="http://www.aboutcookies.org" target="_blank">http://www.aboutcookies.org</a>.
  </p>

  <h2>DEZAKTYWACJA PLIKÓW COOKIES</h2>

  <p>
    Możesz łatwo dostosować ustawienia Twojej przeglądarki w odniesieniu do aktywacji oraz dezaktywacji plików Cookies.
    Prosimy o zapoznanie się opcją pomocy Twojej wyszukiwarki w razie potrzeby.
  </p>

  <h2>RODZAJE I ROLA PLIKÓW COOKIES</h2>

  <p>
    Wiele plików Cookies jest wykorzystywanych w celu zwiększenia użyteczności oraz polepszenia funkcjonalności stron
    internetowych/aplikacji. Z tego względu wyłączenie plików Cookies może uniemożliwić Ci korzystanie z niektórych
    części naszych stron internetowych/aplikacji, tak jak to wskazano w tabeli dotyczącej plików Cookies.
  </p>

  <!-- OneTrust Cookies List start -->
  <div id="ot-sdk-cookie-policy"></div>
  <!-- OneTrust Cookies List end -->

  <small>
    Firma L’Oréal Polska Sp. z o.o. jest odpowiedzialna za dane osobowe, którymi się z nami dzielisz. Kiedy mówimy
    „L’Oréal”, „nam”, „nasze”, „my”, właśnie do tego podmiotu się odnosimy. L’Oréal jest „administratorem” w rozumieniu
    właściwego prawa ochrony danych. <br /><br />
    L’Oréal Polska Sp. z o.o.<br />
    Ul. Grzybowska 62<br />
    00-844 Warszawa<br />
    <a href="https://proconnect.loreal.pl/" target="_blank">https://proconnect.loreal.pl/</a>
    <br /><br />
    Spółka powołała Inspektora Ochrony Danych dostępnego pod adresem
    <a href="mailTo:personal-da@loreal.com">personal-da&#64;loreal.com</a>.
  </small>
</div>
